import { render } from "./MobileNotaryPricingTeaser.vue?vue&type=template&id=af6474e2"
import script from "./MobileNotaryPricingTeaser.vue?vue&type=script&lang=js"
export * from "./MobileNotaryPricingTeaser.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ContentCreator/Functional/MobileNotaryPricingTeaser.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "af6474e2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('af6474e2', __exports__)) {
    api.reload('af6474e2', __exports__)
  }
  
  module.hot.accept("./MobileNotaryPricingTeaser.vue?vue&type=template&id=af6474e2", () => {
    api.rerender('af6474e2', render)
  })

}


export default __exports__